import { render, staticRenderFns } from "./STableTypeCompanyComp.vue?vue&type=template&id=3837f7b3&"
import script from "./STableTypeCompanyComp.vue?vue&type=script&lang=js&"
export * from "./STableTypeCompanyComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports